import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';

export default function FeedbackModal({ open, onClose, onSubmit }) {
    const [feedbackText, setFeedbackText] = useState('');

    const handleSubmit = () => {
        onSubmit(feedbackText);
        setFeedbackText('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Provide Additional Feedback</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Your Feedback"
                    type="text"
                    fullWidth
                    multiline
                    minRows={3}
                    value={feedbackText}
                    onChange={(e) => setFeedbackText(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">Cancel</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">Submit</Button>
            </DialogActions>
        </Dialog>
    );
}
